import $ from 'jquery';

window.addEventListener('load', function() {
  $('#gform_submit_button_3').attr('disabled', 'disabled');
  let zipcode = $('#input_3_51_5');
  if (zipcode.length > 0) {
    zipcode.on('change', function() {
      if (zipcode.val().length === 5) {
        if (zipcode.val()[0] === '3' && zipcode.val()[1] === '4') {
          $('#gform_submit_button_3').attr('disabled', false);
        } else {
          $('#gform_submit_button_3').attr('disabled', 'disabled');
        }
      } else {
        $('#gform_submit_button_3').attr('disabled', 'disabled');
      }
    })
  }
});
